import Vue from 'vue';
import App from './App.vue';
import router from './router'; // 导入路由配置
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import store from './store'
import api from "./service/api.js";
import i18n from './i18n'
// import translate from 'i18n-jsautotranslate';

import './assets/fonts/font.css'

Vue.prototype.axios = axios

// // 是否显示语言切换栏
// translate.selectLanguageTag.show = false;

// // 监控页面动态渲染的文本进行自动翻译
// translate.listener.start();

// // Vue 2
// Vue.prototype.$translate = translate;


// //将封装的接口挂载到vue原型上
Vue.prototype.$api = api;

Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
	render: (h) => h(App),
	i18n,
	store,
	router, // 使用路由
}).$mount('#app');